import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseHttpClient } from '@bayclubs/utils';

import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SubBoardHttpClient extends BaseHttpClient {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getUrl(): string {
        return environment.subBoardApiUrl;
    }
}
